import { fetchPublication, updateProfile, fetchProfile, getNotifications, readNotification } from "@/services/userService";

const state = {
    profile: [],
    notifications: null,
    notificationAmount: 0
};

const mutations = {
    SET_PUBLICATION(state, publication) {
        state.publication = publication;
    },
    SET_PROFILE(state, profile) {
        state.profile = profile;
    },
    SET_NOTIFICATION(state, notifications) {
        state.notifications = notifications;
    },
    SET_NOTIFICATION_AMOUNT(state, amount) {
        state.notificationAmount = amount;
    },
    RESET_ALL_PROFILE_STATE(state) {
        state.profile = [];
        state.notifications = null;
        state.notificationAmount = 0;
    }
};

const actions = {
    async fetchPublication({ commit }) {
        try {
            const publication = await fetchPublication();

            publication.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            commit('SET_PUBLICATION', publication);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },

    async fetchProfile({ commit }) {
        try {
            const profile = await fetchProfile();
            commit('SET_PROFILE', profile);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },

    async updateProfile({ commit }, formData) {
        try {
            const profile = await updateProfile(formData);
            commit('SET_PROFILE', profile);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    
    async fetchNotifications ({ commit }) {
        try {
            const notification = await getNotifications();
            commit('SET_NOTIFICATION', notification);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },

    countNotification({ commit, state }, type) {
        let unreadNotifications = state.notifications.data.filter(notification => !notification.read_at).length;
        let amount = type === 'minus' ? Math.max(0, unreadNotifications - 1) : unreadNotifications;
    
        commit('SET_NOTIFICATION_AMOUNT', amount);
    },
    

    async readNotification ({ commit }, id) {
        try {
            const read = await readNotification(id);

            return read;
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
    
    resetAllProfileState({commit}) {
        commit('RESET_ALL_PROFILE_STATE')
    }
};

const getters = {
    getPublication: state => state.publication,
    getProfile: state => state.profile,
    getNotifications: state => state.notifications,
    getNotificationAmount: state => state.notificationAmount
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
